module.exports = __webpack_public_path__ + "assets/21399dc929d85ef66fe3aa4e245fd95f.svg";